import { z } from 'zod';
import { documentIdSchema, documentSummarySchema } from './documents';

/** A place in a document: a section and the block within it. */
export const readingPositionSchema = z.object({
  section: z.number().int().min(0),
  block: z.number().int().min(0),
});
export type ReadingPosition = z.infer<typeof readingPositionSchema>;

export const readingProgressSchema = readingPositionSchema.extend({
  documentId: documentIdSchema,
  /** 0 to 100, one decimal. */
  percent: z.number().min(0).max(100),
  startedAt: z.string(),
  updatedAt: z.string(),
});
export type ReadingProgress = z.infer<typeof readingProgressSchema>;

export const readingEntrySchema = readingProgressSchema.extend({
  document: documentSummarySchema,
  sectionTitle: z.string(),
});
export type ReadingEntry = z.infer<typeof readingEntrySchema>;

export const bookmarkSchema = readingPositionSchema.extend({
  id: z.number().int(),
  documentId: documentIdSchema,
  sectionTitle: z.string(),
  excerpt: z.string(),
  note: z.string().nullable(),
  createdAt: z.string(),
});
export type Bookmark = z.infer<typeof bookmarkSchema>;

export const bookmarkWithDocumentSchema = bookmarkSchema.extend({
  document: documentSummarySchema,
});
export type BookmarkWithDocument = z.infer<typeof bookmarkWithDocumentSchema>;

const noteSchema = z.string().trim().max(500).nullable();

export const createBookmarkSchema = readingPositionSchema.extend({
  documentId: documentIdSchema,
  note: noteSchema.optional(),
});
export type CreateBookmark = z.infer<typeof createBookmarkSchema>;

export const updateBookmarkSchema = z.object({ note: noteSchema });
export type UpdateBookmark = z.infer<typeof updateBookmarkSchema>;

export const bookmarkListQuerySchema = z.object({
  documentId: documentIdSchema.optional(),
});
